// Vue Js
import Vue from 'vue'

// jQuert & Bootstrap
window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery')
require('bootstrap')

// Lodash
import lodash from 'lodash'
window._ = lodash

